import React, { useState, useEffect } from "react";
import { Container, Col, Image, Row, Card } from "react-bootstrap";
import axios from "axios";
import { apiUrl } from "../commons/inFormTypes";
import { IPUrl } from "../commons/IPAddress";
import { NavLink, useNavigate, useParams } from 'react-router-dom'
import AllHeader from "../components/AllHeader";
import NotInfo from "../components/NotInfo";
import useCheckUser from "../custom-hooks/useCheckUser";


function Places() {
  const [load, setLoad] = useState(false);
  const [seenFile, setSeenFile] = useState([]);
  const UserID = localStorage.getItem("UserId");
  const params = useParams()


    // Example usage of the custom hook
    useCheckUser(UserID); // Replace UserID with the actual user ID value

  useEffect(() => {
      setLoad(true)
      const axios = require("axios");
      axios.post(apiUrl + "GetPlaceList", {
        type: params.placesId,
        Uid: UserID
      }
      ).then((res) => {
        if (res.data.result === "true") {
          setSeenFile(res.data.data)
          setLoad(false)
        } else {

        }
      });
  }, [params.placesId]);

  return (
    <div className="rgc-pages">
      <AllHeader>
        {(() => {
          switch (params.placesId) {
            case '1':
              return (<span>اماکن گردشگری</span>)
            case '2':
              return (<span>اماکن مذهبی</span>)
            default:
              return (<span> اماکن</span>)
          }

        })()
        }
      </AllHeader>
      <Container>
        <Row className="justify-content-start">

          {load === false && seenFile.length === 0 ?
            <NotInfo />
            :
            seenFile.map((data, index) => {
              return (
                <Col xs={12} sm={6} lg={4} className="rgc-news-item" key={index}>
                  <NavLink to={"/Internalplaces/" + data.Id} state={data.Tittle}>
                    <Card className="rgc-news">
                      <Row>
                        <Col xs={5} className="rgc-img-news">
                          <Image src={IPUrl + "/UploadedFile/Places/Ssn/" + data.Pic} alt="" fluid />
                        </Col>
                        <Col xs={7} className="rgc-text-news">
                          {data.Tittle.length > 60 ? <p>{data.Tittle.substring(0, 60) + "..."}</p> : <p>{data.Tittle} </p>}
                          {data.Chekideh.length > 60 ? <p><i className="fa fa-map-marker-alt rgc-text-icon" aria-hidden="true"  ></i><br />{data.Chekideh.substring(0, 60) + "..."}</p> : <p><i className="fa fa-map-marker-alt rgc-text-icon" aria-hidden="true"  ></i><br />{data.Chekideh} </p>}
                        </Col>
                      </Row>
                    </Card>
                  </NavLink>
                </Col>

              )
            })
          }
        </Row>
      </Container>
    </div>
  );
}

export default Places;
